import { useTranslation } from "react-i18next";

export function LocaleSwitcher() {
  const { i18n, t } = useTranslation();

  function changeTo(lng: "fr" | "ar") {
    void i18n.changeLanguage(lng);
  }

  // min-h-11 (44px) meets the UXC mobile touch-target guideline on every surface
  // that renders the switcher (admin/merchant/enrolment/welcome). inline-flex keeps
  // the label centered in the taller pill. (UAT Phase 9 → UI-09-TAPTARGET.)
  const base =
    "inline-flex items-center justify-center rounded-full border px-4 min-h-11 text-sm font-medium transition-smooth";
  const active = "border-primary bg-primary text-primary-foreground shadow-sm";
  const inactive =
    "border-border bg-background/60 text-foreground hover:border-primary hover:text-primary";

  return (
    <nav aria-label={t("nav.language")} className="flex gap-2">
      <button
        type="button"
        onClick={() => changeTo("fr")}
        aria-pressed={i18n.language === "fr"}
        className={`${base} ${i18n.language === "fr" ? active : inactive}`}
      >
        {t("nav.french")}
      </button>
      <button
        type="button"
        onClick={() => changeTo("ar")}
        aria-pressed={i18n.language === "ar"}
        className={`${base} ${i18n.language === "ar" ? active : inactive}`}
      >
        {t("nav.arabic")}
      </button>
    </nav>
  );
}
